<template>
  <h2 class="titleStepForm">
    Appointment of Nominee <sup>(Beneficiary)</sup>
  </h2>
  <div class="">
    <p>
      In the event of my death I,
      <strong>{{ form.personal9.appliname }} </strong> hereby
      nominate the following person(s) to receive any monies
      accruing to me in the Society:
    </p>
    <div class="groupFeildsNom border-bottom pb-3 mb-3">
      <div class="row">
        <div class="col-lg-4 mb-3">
          <label class="font-size-14"> Name</label>
          <input placeholder="Enter nominee name"
            type="text"
            v-model="form.personal8.appointnominee_name1"
            class="form-control"
            :class="{
              'is-invalid':
                v$.form.personal8.appointnominee_name1.$error,
            }"
          />
          <div
            v-for="(personal8, index) in v$.form.personal8
              .appointnominee_name1.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal8.$message">{{
              personal8.$message
            }}</span>
          </div>
        </div>
        <div class="col-lg-8 mb-3">
          <label class="font-size-14"> Email Address</label>
          <input placeholder="Enter email address"
            type="email"
            v-model="form.personal8.appointnominee_email1"
            maxlength="100"
            class="form-control"
            :class="{
              'is-invalid':
                v$.form.personal8.appointnominee_email1
                  .$error,
            }"
          />
          <div
            v-for="(personal8, index) in v$.form.personal8
              .appointnominee_email1.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal8.$message">{{
              personal8.$message
            }}</span>
          </div>
        </div>
        <template v-if="isEdit">
        <div class="d-block">
          <label class="font-size-14">Phone Number</label
          ><span>(Numbers only)</span>
          <div class="d-flex">
            <div
              class="single-select2-cstm"
              style="min-width: 96px;margin-right: 10px;"
            >
              <Select2 placeholder="Code"
                v-model="
                  form.personal8.appointnominee_pno1code
                "
                :options="countrynameIssuanceOpt"
                :class="{
                  'is-invalid':
                    v$.form.personal8.appointnominee_pno1code
                      .$error,
                }"
              >
              </Select2>
              <div
                v-for="(personal8, index) in v$.form.personal8
                  .appointnominee_pno1code.$errors"
                :key="index"
                class="invalid-feedback"
              >
                <span v-if="personal8.$message">{{
                  personal8.$message
                }}</span>
              </div>
            </div>

            <div class="d-block">
              <input
                type="number"
                placeholder="No dashes or spaces"
                v-model="form.personal8.appointnominee_pno1"
                class="form-control"
                inputmode="numeric"
                :class="{
                  'is-invalid':
                    v$.form.personal8.appointnominee_pno1
                      .$error,
                }"
                @input="validatemobnumber5"
              />
              <div class="invalid-feedback"
                v-if="ispassnumberInvalid5"
                >Atleast 9 number required</div>
              <div
                v-for="(personal8, index) in v$.form.personal8
                  .appointnominee_pno1.$errors"
                :key="index"
                class="invalid-feedback"
              >
                <span
                  class="d-block"
                  v-if="personal8.$message"
                  >{{ personal8.$message }}</span
                >
              </div>
            </div>
          </div>
        </div>
        </template>
        <template v-if="!isEdit">

        <div class="col-lg-4 mb-3">
          <label class="font-size-14">Phone Number</label
          ><span> (Numbers only)</span>
          <div class="d-flex">
            <div
              class="single-select2-cstm"
              style="min-width: 96px;margin-right: 10px;"
            >
              <Select2 placeholder="Code"
                v-model="
                  form.personal8.appointnominee_pno1code
                "
                :options="countrynameIssuanceOpt"
                :class="{
                  'is-invalid':
                    v$.form.personal8.appointnominee_pno1code
                      .$error,
                }"
              >
              </Select2>
              <div
                v-for="(personal8, index) in v$.form.personal8
                  .appointnominee_pno1code.$errors"
                :key="index"
                class="invalid-feedback"
              >
                <span v-if="personal8.$message">{{
                  personal8.$message
                }}</span>
              </div>
            </div>

            <div class="w-100">
              <input
                type="number"
                placeholder="No dashes or spaces"
                v-model="form.personal8.appointnominee_pno1"
                class="form-control"
                inputmode="numeric"
                :class="{
                  'is-invalid':
                    v$.form.personal8.appointnominee_pno1
                      .$error,
                }"
                @input="validatemobnumber5"
              />
              <div class="invalid-feedback"
                v-if="ispassnumberInvalid5"
                >Atleast 7 number required</div>
              <div
                v-for="(personal8, index) in v$.form.personal8
                  .appointnominee_pno1.$errors"
                :key="index"
                class="invalid-feedback"
              >
                <span
                  class="d-block"
                  v-if="personal8.$message"
                  >{{ personal8.$message }}</span
                >
              </div>
            </div>
          </div>
        </div>
        </template>
        <!-- Optional validation: appointnominee_pno1 -->
        <div class="col-lg-4 mb-3">
          <label class="font-size-14"> Rel. to Member</label>
          <div class="single-select2-cstm">
            <Select2 placeholder="Select relationship"
              v-model="form.personal8.appointnominee_rel1"
              :options="relationNameOpt"
              :class="{
                'is-invalid':
                  v$.form.personal8.appointnominee_rel1
                    .$error,
              }"
            />
            <div
              v-for="(personal8, index) in v$.form.personal8
                .appointnominee_rel1.$errors"
              :key="index"
              class="invalid-feedback"
            >
              <span v-if="personal8.$message">{{
                personal8.$message
              }}</span>
            </div>
          </div>
          <template v-if="isEdit">
          <!-- Optional form input -->
          <!-- Optional validation: appointnominee_rel1 -->
          </template>
        </div>
        <div
          class="col-lg-4 mb-3"
          v-if="
            form.personal8.appointnominee_rel1 ===
            'Other family member'
          "
        >
          <label class="font-size-14">
            Specify The Relation</label
          >
          <input placeholder="Specify relationship"
            type="textarea"
            v-model="form.personal8.appointnominee_otherel"
            class="form-control"
          />
        </div>
        <div class="col-lg-4 mb-3">
          <label class="font-size-14"> Date of Birth</label>
          <AppDatePicker v-model="form.personal8.appointnominee_dob1" placeholder="Select date of birth" past-only :invalid="v$.form.personal8.appointnominee_dob1.$error" />
          <div class="invalid-feedback" v-if="isInvalidDOB1"
            >Date of Birth cannot be greater than the current
            date.</div>
          <div
            v-for="(personal8, index) in v$.form.personal8
              .appointnominee_rel1.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal8.$message">{{
              personal8.$message
            }}</span>
          </div>
        </div>
        <div class="col-lg-12 mb-3">
          <label class="font-size-14">Address</label>
          <input placeholder="Enter address"
            type="textarea"
            v-model="form.personal8.appointnominee_address1"
            maxlength="210"
            class="form-control"
            :class="{
              'is-invalid':
                v$.form.personal8.appointnominee_address1
                  .$error,
            }"
          />
          <div
            v-for="(personal8, index) in v$.form.personal8
              .appointnominee_address1.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal8.$message">{{
              personal8.$message
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="groupFeildsNom border-bottom pb-3 mb-3">
      <div class="row">
        <div class="col-lg-4 mb-3">
          <label class="font-size-14"> Name </label>
          <input placeholder="Enter nominee name"
            type="text"
            v-model="form.personal8.appointnominee_name2"
            class="form-control"
          />
          <!-- Optional validation: appointnominee_name2 -->
        </div>
        <div class="col-lg-8 mb-3">
          <label class="font-size-14"> Email Address</label>
          <input placeholder="Enter email address"
            type="email"
            v-model="form.personal8.appointnominee_email2"
            maxlength="100"
            class="form-control"
          />
          <!-- Optional validation: appointnominee_email2 -->
        </div>
        <template v-if="isEdit">
        <!-- Optional validation: appointnominee_pno2code -->
        </template>
        <template v-if="!isEdit">

        </template>
        <div class="col-lg-4 mb-3">
          <template v-if="isEdit">
          <label class="font-size-14"> Phone Number</label>
          <input placeholder="Enter phone number"
            type="number"
            inputmode="numeric"
            v-model="form.personal8.appointnominee_pno2"
            class="form-control"
            @input="validatemobnumber4"
          />
          <div class="invalid-feedback"
            v-if="ispassnumberInvalid"
            >Atleast 9 number required</div>
          <!-- Optional validation: appointnominee_pno2 -->
          </template>
          <template v-if="!isEdit">
          <label class="font-size-14"> Phone Number</label
          ><span> (Numbers only)</span>
          <div class="d-flex">
            <div
              class="single-select2-cstm"
              style="min-width: 96px;margin-right: 10px;"
            >
              <Select2 placeholder="Code"
                v-model="
                  form.personal8.appointnominee_pno2code
                "
                :options="countrynameIssuanceOpt"
              >
              </Select2>
              <!-- Optional validation: appointnominee_pno2code -->
              <!-- Optional validation: appointnominee_pno2code -->
            </div>

            <div class="w-100">
              <input
                type="number"
                placeholder="No dashes or spaces"
                inputmode="numeric"
                v-model="form.personal8.appointnominee_pno2"
                class="form-control"
                @input="validatemobnumber4"
              />
              <div class="invalid-feedback"
                v-if="ispassnumberInvalid"
                >Atleast 7 number required</div>
            </div>
            <!-- Optional validation: appointnominee_pno2 -->
          </div>
          </template>
        </div>
<template v-if="!isEdit">

</template>
        <div class="col-lg-4 mb-3">
          <label class="font-size-14"> Rel. to Member</label>
          <div class="single-select2-cstm">
            <Select2 placeholder="Select relationship"
              v-model="form.personal8.appointnominee_rel2"
              :options="relationNameOpt"
            />
          </div>
        </div>
        <div
          class="col-lg-4 mb-3"
          v-if="
            form.personal8.appointnominee_rel2 ===
            'Other family member'
          "
        >
          <label class="font-size-14">
            Specify The Relation</label
          >
          <input placeholder="Specify relationship"
            type="textarea"
            v-model="form.personal8.appointnominee_othere2"
            class="form-control"
          />
        </div>

        <div class="col-lg-4 mb-3">
          <label class="font-size-14"> Date of Birth</label>
          <AppDatePicker v-model="form.personal8.appointnominee_dob2" placeholder="Select date of birth" past-only />
          <div class="invalid-feedback" v-if="isInvalidDOB2"
            >Date of Birth cannot be greater than the current
            date.</div>
          <!-- Optional validation: appointnominee_dob2 -->
        </div>
        <div class="col-lg-12 mb-3">
          <label class="font-size-14"> Address</label>
          <input placeholder="Enter address"
            type="textarea"
            v-model="form.personal8.appointnominee_address2"
            maxlength="210"
            class="form-control"
          />
          <!-- Optional validation: appointnominee_address2 -->
        </div>
      </div>
    </div>
    <div class="">
      <p>
        I reserve the right to change or terminate the
        designated beneficiary/ies at any time. I further
        agree that any designation, termination or change of
        beneficiary shall be binding upon the Credit Union
        only if filed with the Credit Union prior to my death.
        In accordance with the Co-operative Societies Act Chap
        81:03 , as outlined in
        <strong>ECU’s Bye Laws #10,</strong> a duly named
        nominee of a deceased member of the Society is
        <template v-if="isEdit">
        entitled to the sum not exceeding five thousand
        </template>
        <template v-if="!isEdit">
        entitled to the sum not exceeding fifty thousand
        </template>
        dollars ($50,000.00) of the unencumbered money due to
        the death of the said member of the Society. All other
        monies due to the deceased member shall fall into his
        estate and be subject in all respects to the laws
        relating to inheritance including the requirement to
        pay estate duty.
      </p>
      <div
        class="minorDivShow"
        v-if="radioSelected1 === 'minor'"
      >
        <h6 class="font-size-15">
          Complete this Section only if Nominee is a minor
        </h6>
        <label
          for="hereByRd"
          class="w-100 b-0 p-relative labelStyleRadioCstm pt-0 pb-0"
        >
          <!-- :class="{'is-invalid': v$.form.personal8.hereRadioType.$error}" -->
          <input
            type="checkbox"
            :checked="
              radioSelected1 === 'minor' ? 'true' : 'false'
            "
            v-model="form.personal8.hereRadioType"
            class="inputRadioCstm d-none"
            id="hereByRd"
            value="True"
          />
          <span class="radioCircleIcon line-height-1">
            <i
              class="mdi mdi-checkbox-blank-outline text-theme font-size-22"
            ></i>
            <i
              class="mdi mdi-check-box-outline text-theme theme-check font-size-22"
            ></i>
          </span>
          <h4
            class="font-size-13 line-height-17 text-dark-custom font-weight-400 mb-0 ms-1"
          >
            I hereby nominate the following person/company to
            act as; Trustee/Guardian on behalf of my nominee
            should my nominee still be a minor (under age 18)
            upon my death.
          </h4>
        </label>
        <!-- Optional validation: hereRadioType -->
        <div class="row align-items-center">
          <div class="col-lg-4 mb-3">
            <div class="row gx-2">
              <div class="col-auto">
                <label
                  for="trusteeRd"
                  class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                >
                  <!-- :class="{'is-invalid': v$.form.personal8.trusteeRadioo.$error}" -->
                  <input
                    type="radio"
                    v-model="form.personal8.trusteeRadioo"
                    value="trustee"
                    class="inputRadioCstm d-none"
                    id="trusteeRd"
                  />
                  <span class="radioCircleIcon">
                    <i
                      class="mdi mdi-circle-outline text-theme font-size-20"
                    ></i>
                    <i
                      class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                    ></i>
                  </span>
                  <h4
                    class="font-size-14 text-dark-custom mb-0 ms-1"
                  >
                    Trustee
                  </h4>
                </label>
                <!-- Optional validation: trusteeRadioo -->
              </div>
              <div class="col-auto">
                <label
                  for="guardianRd"
                  class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                >
                  <!-- :class="{'is-invalid': v$.form.personal8.trusteeRadioo.$error}" -->
                  <input
                    type="radio"
                    v-model="form.personal8.trusteeRadioo"
                    value="guardian"
                    class="inputRadioCstm d-none"
                    id="guardianRd"
                  />
                  <span class="radioCircleIcon">
                    <i
                      class="mdi mdi-circle-outline text-theme font-size-20"
                    ></i>
                    <i
                      class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                    ></i>
                  </span>
                  <h4
                    class="font-size-14 text-dark-custom mb-0 ms-1"
                  >
                    Guardian
                  </h4>
                </label>
                <!-- Optional validation: trusteeRadioo -->
              </div>
            </div>
          </div>
          <div class="col-lg-8 mb-3">
            <div class="d-block">
              <label class="font-size-14"
                >Relationship to Beneficiary</label
              >
              <div class="single-select2-cstm">
                <Select2 placeholder="Select relationship"
                  v-model="form.personal8.relationbenifit3"
                  :options="relationNameOpt"
                  @input="validatemobnumber6"
                />
                <template v-if="isEdit">
                <div class="invalid-feedback"
                  v-if="ispassnumberInvalid"
                  >Atleast 9 number required</div>
                </template>
                <template v-if="!isEdit">
                <div class="invalid-feedback"
                  v-if="ispassnumberInvalid"
                  >Atleast 7 number required</div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-lg-4 mb-3"
          v-if="
            form.personal8.relationbenifit3 ===
            'Other family member'
          "
        >
          <label class="font-size-14">
            Specify The Relation</label
          >
          <input placeholder="Specify relationship"
            type="textarea"
            v-model="form.personal8.appointnominee_othere3"
            class="form-control"
          />
        </div>
        <div class="groupFeildsNom border-top pt-3 mt-3">
          <div class="row">
            <div class="col-lg-4 mb-3">
              <label class="font-size-14"> Name</label>
              <input placeholder="Enter nominee name"
                type="text"
                v-model="form.personal8.appointnominee_name3"
                class="form-control"
              />
              <!-- Optional validation: appointnominee_name3 -->
            </div>
            <template v-if="isEdit">
            <div class="col-lg-8 mb-3">
              <label class="font-size-14">
                Email Address</label
              >
              <input placeholder="Enter email address"
                type="email"
                v-model="form.personal8.appointnominee_email3"
                maxlength="100"
                class="form-control"
              />
              <!-- Optional validation: appointnominee_email3 -->
            </div>
            <div class="col-lg-4 mb-3">
              <label class="font-size-14">
                Phone Number</label
              >
              <input placeholder="Enter phone number"
                type="number"
                inputmode="numeric"
                v-model="form.personal8.appointnominee_pno3"
                class="form-control"
                @input="validatemobnumber10"
              />
              <div class="invalid-feedback"
                v-if="ispassnumberInvalid10"
                >Atleast 9 number required</div>

              <!-- Optional validation: appointnominee_pno3 -->
            </div>
            </template>
            <template v-if="!isEdit">
            <div class="col-lg-4 mb-3">
              <label class="font-size-14">
                Email Address</label
              >
              <input placeholder="Enter email address"
                type="email"
                v-model="form.personal8.appointnominee_email3"
                maxlength="100"
                class="form-control"
              />
              <!-- Optional validation: appointnominee_email3 -->
            </div>
            </template>
            <div class="col-lg-4 mb-3">
              <label class="font-size-14">
                Date of Birth</label
              >
              <AppDatePicker v-model="form.personal8.appointnominee_dob3" placeholder="Select date of birth" past-only />
              <div class="invalid-feedback" v-if="isInvalidDOB3"
                >Date of Birth cannot be greater than the
                current date.</div>
              <!-- Optional validation: appointnominee_dob3 -->
            </div>
            <template v-if="isEdit">
            <div class="col-lg-12 mb-3">
              <label class="font-size-14"> Address</label>
              <input placeholder="Enter address"
                type="textarea"
                v-model="
                  form.personal8.appointnominee_address3
                "
                maxlength="210"
                class="form-control"
              />
              <!-- Optional validation: appointnominee_address3 -->
            </div>
            </template>
            <template v-if="!isEdit">
            <div class="col-lg-4 mb-3">
              <label class="font-size-14"> Phone Number</label
              ><span> (Numbers only)</span>
              <div class="d-flex">
                <div
                  class="single-select2-cstm"
                  style="min-width: 96px;margin-right: 10px;"
                >
                  <Select2 placeholder="Code"
                    v-model="
                      form.personal8.appointnominee_pno3code
                    "
                    :options="countrynameIssuanceOpt"
                  >
                  </Select2>
                </div>
                <div class="w-100">
                  <input placeholder="Enter phone number"
                    type="number"
                    inputmode="numeric"
                    v-model="
                      form.personal8.appointnominee_pno3
                    "
                    class="form-control"
                    @input="validatemobnumber10"
                  />
                  <div class="invalid-feedback"
                    v-if="ispassnumberInvalid10"
                    >Atleast 7 number required</div>
                </div>
              </div>
              <!-- Optional validation: appointnominee_pno3 -->
            </div>

            <div class="col-lg-8 mb-3">
              <label class="font-size-14"> Address</label>
              <input placeholder="Enter address"
                type="textarea"
                v-model="
                  form.personal8.appointnominee_address3
                "
                maxlength="210"
                class="form-control"
              />
              <!-- Optional validation: appointnominee_address3 -->
            </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "vue3-select2-component";
import { bridge } from "../formBridge";
import AppDatePicker from "@/components/shared/AppDatePicker.vue";

export default {
  name: "NomineeStep",
  props: {
    mode: { type: String, default: "create" },
  },
  computed: {
    isEdit() {
      return this.mode === "edit";
    },
  },
  mixins: [
    bridge({
    state: ["radioSelected1", "relationNameOpt", "countrynameIssuanceOpt", "isInvalidDOB1", "isInvalidDOB2", "isInvalidDOB3", "form", "ispassnumberInvalid", "ispassnumberInvalid5", "ispassnumberInvalid10"],
    methods: ["validatemobnumber4", "validatemobnumber6", "validatemobnumber5", "validatemobnumber10"],
    validate: true,
    }),
  ],
  components: { Select2, AppDatePicker },
};
</script>